import { useState } from "react";
import Thanishq from "../../styles/ThanishqStyle.css"

function TopBarOffer(){
    const [showBanner, setShowBanner] = useState(true); 

    const handleClosed = () => {
      setShowBanner(false);
    };
  
    if (!showBanner) return null;
return(
<div>
{/* <div style={{background: "#ffe9ec",  position: "relative", padding: "auto"}}>
  <div className="offer d-flex justify-content-center align-items-center">
    <span>Akshaya Tritiya Offer is Live - Up to 20% Off*</span> 
    <button style={{border:"1px solid black",borderRadius:"25px"}} className="  text-dark  ms-3">
      Shop Now
    </button>
  </div>

  <button 
    onClick={handleClosed}
    type="button" 
    className="btn-close" 
    aria-label="Close"
    style={{position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)"}}
  >
  </button>
</div> */}
</div>
);

}

export default TopBarOffer


